import { create } from 'zustand'
import { UsersResponse, Collections } from '../pocketbase-types'
import { pbClient } from '../lib/PB/pb'
import { currentUserStorageKey } from '../Consts/Consts'

export const defaultUserValues = {
    verified: false,
    avatar: '',
    collectionId: '',
    collectionName: Collections.Users,
    created: '',
    email: '',
    id: '',
    emailVisibility: false,
    name: '',
    roles: [],
    updated: '',
    username: '',
    expand: {}
}

type UserStore = {
    loggedInUser: UsersResponse,
    setLoggedInUser: (user: UsersResponse) => void,
    logedIn: boolean,
    setIsLoggedIn: (isLogged: boolean) => void,
}

export const useUserStore = create<UserStore>((set) => {
    return {
        loggedInUser: !!localStorage.getItem(currentUserStorageKey) ? JSON.parse(localStorage.getItem(currentUserStorageKey)) as UsersResponse : defaultUserValues,
        setLoggedInUser(user) {
            set({ loggedInUser: user })
            localStorage.setItem(currentUserStorageKey, JSON.stringify(user));
        },
        logedIn: !!pbClient.authStore.token,
        setIsLoggedIn(isLogged) {
            set({ logedIn: isLogged })
        }
    }
})